





import { store } from "@/store";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ActionDef } from '@/App.vue';

@Component
export default class Action extends Vue
{
  @Prop() private definition!: ActionDef;

  public act()
  {
    store.handleAction(this.definition);
  }
}
